var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgActivate = function SvgActivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#5dbfd5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.775 19.125a.296.296 0 01-.17-.054.306.306 0 01-.098-.385l2.783-5.632H8.175a.3.3 0 01-.252-.14.307.307 0 01-.022-.289l2.7-6.07a.3.3 0 01.274-.18h3.9a.3.3 0 01.255.144c.055.09.06.201.013.295l-1.583 3.204h3.115a.3.3 0 01.275.182c.048.11.026.24-.055.328l-7.8 8.5a.298.298 0 01-.22.097z"
  }))));
};

export default SvgActivate;